import styled from 'styled-components';
import { lightBlack, gray } from '@styles/colors';

export const FooterWrapper = styled.footer`
  background: ${lightBlack};
  color: white;
  padding-top: 50px;
  padding-bottom: 50px;
  text-align: center;
  box-sizing: border-box;
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
`;

export const GobLogoLink = styled.a`
  align-self: center;
  
  svg{
    width: 150px;
  }
  
`;

export const FooterColumnWrapper = styled.div`
  text-align: left;
`;

export const FooterTitle = styled.h4`
  font-family: 'Avenir';
  font-weight: 500;
  text-transform: uppercase;
  color: ${gray};
  font-size: 1.1rem;
  margin-bottom: 1rem;
  letter-spacing: 1px;
`;

export const HorizontalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const HorizontalWrapperTop = HorizontalWrapper.extend`
  align-items: flex-start;
`;

export const SocialText = styled.p`
  font-family: 'Avenir';
  font-size: 0.8rem;
  font-weight: 300;
  text-transform: uppercase;
  color: ${gray};
  margin: 0.5rem;
  letter-spacing: 2px;
  paddin-left: 1rem;
`;

export const IconWrapper = styled.div`
  padding: 0.8rem;
`;

export const LocationTextWrapper = styled.p`
  font-size: 1rem;
  font-weight: 100;
  font-family: 'Avenir';
  line-height: 1.5;
  color: ${gray};
  padding-top: 0.4rem;
`;

export const MailText = styled.p`
  font-size: 1rem;
  font-weight: 100;
  font-family: 'Avenir';
  color: ${gray};
`;

export const Link = styled.a`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &:hover p {
    text-decoration: underline;
    
  }
`;


// WEBPACK FOOTER //
// src/app/src/components/Footer/Footer.s.ts